module.exports = __webpack_public_path__ + "media/images/attention-7018bc21cb6406a0249b89c1078fc2e1.png";